import React from 'react';
import { motion } from 'motion/react';
import { Sparkles, Zap, Layout, Share2 } from 'lucide-react';
import SEO from '../../components/SEO';
import { Link } from 'react-router-dom';

const Creators = () => {
  return (
    <div className="pt-24 pb-24 bg-[#030303] min-h-screen">
      <SEO 
        title="AI Social Media Tool for Creators - PlataPost"
        description="Amplify your reach as a creator with PlataPost's AI tools. Generate content ideas, write viral captions, and manage your calendar in one place."
      />

      <div className="max-w-7xl mx-auto px-6">
        <div className="flex flex-col lg:flex-row items-center gap-20 mb-40">
          <div className="flex-1 space-y-8">
            <div className="inline-flex items-center gap-3 px-4 py-1.5 rounded-full glass-card border border-white/5 text-indigo-400 text-[10px] font-black uppercase tracking-widest leading-none">
              <Sparkles className="w-3.5 h-3.5" />
              <span>Creator Focused</span>
            </div>
            <h1 className="text-5xl lg:text-7xl font-black text-white leading-tight tracking-tighter">AI for Digital <br /> <span className="text-indigo-500">Creators.</span></h1>
            <p className="text-xl text-gray-400 mb-8 leading-relaxed font-medium">
              You create the magic. We handle the management. PlataPost helps creators turn one core idea into a week of multi-platform distribution.
            </p>
            <Link to="/dashboard" className="inline-flex px-10 py-5 bg-indigo-600 text-white rounded-2xl font-black uppercase tracking-widest text-xs hover:bg-indigo-700 transition-all shadow-2xl shadow-indigo-600/30">
               Amplify My Brand
            </Link>
          </div>
          <div className="flex-1 w-full glass-card rounded-[4rem] p-12 flex items-center justify-center border border-white/5 relative overflow-hidden group shadow-2xl shadow-indigo-600/5">
             <div className="absolute inset-0 bg-gradient-to-br from-indigo-500/10 to-purple-500/10 blur-[100px] pointer-events-none" />
             <div className="relative p-10 bg-white/5 rounded-[2.5rem] border border-white/10 shadow-2xl space-y-6 group-hover:scale-105 transition-transform duration-700">
                <div className="h-4 w-3/4 bg-white/10 rounded-full animate-pulse" />
                <div className="h-4 w-1/2 bg-white/5 rounded-full" />
                <div className="grid grid-cols-2 gap-4 mt-8">
                   <div className="h-24 bg-indigo-500/10 rounded-2xl border border-indigo-500/20 shadow-xl shadow-indigo-500/5" />
                   <div className="h-24 bg-purple-500/10 rounded-2xl border border-purple-500/20 shadow-xl shadow-purple-500/5" />
                </div>
             </div>
          </div>
        </div>

        <section className="mb-40">
          <div className="text-center mb-24 space-y-4">
            <h2 className="text-4xl lg:text-5xl font-black text-white tracking-tighter leading-tight">Fuel Your Growth</h2>
            <p className="text-gray-400 font-medium max-w-xl mx-auto">Scale your influence across every social channel with automated intelligence.</p>
          </div>
          <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-8">
             {[
               { icon: Sparkles, title: "Viral Ideas", desc: "AI-generated content concepts based on what's trending in your niche." },
               { icon: Layout, title: "Repurposing", desc: "Turn a YouTube script into 10 LinkedIn posts in 30 seconds." },
               { icon: Share2, title: "Omnichannel", desc: "Manage growth on IG, TikTok, and X simultaneously." },
               { icon: Zap, title: "High Speed", desc: "Reduce your management time by up to 90%." }
             ].map((feature, i) => (
                <div key={i} className="text-center p-10 glass-card rounded-[2.5rem] border border-white/5 hover:bg-white/5 transition-all group">
                   <div className="w-20 h-20 bg-white/5 border border-white/10 rounded-2xl flex items-center justify-center mx-auto mb-8 text-indigo-400 group-hover:scale-110 group-hover:rotate-6 transition-all shadow-xl shadow-indigo-600/5">
                      <feature.icon className="w-10 h-10" />
                   </div>
                   <h3 className="font-black text-white text-xl mb-4 tracking-tight">{feature.title}</h3>
                   <p className="text-gray-400 font-medium leading-relaxed">{feature.desc}</p>
                </div>
             ))}
          </div>
        </section>

        <div className="text-center glass-card rounded-[4rem] p-24 border border-white/5 relative overflow-hidden shadow-2xl shadow-indigo-600/5">
           <div className="absolute inset-0 bg-indigo-600/10 blur-[150px] pointer-events-none" />
           <h2 className="text-4xl lg:text-5xl font-black text-white mb-10 tracking-tighter">Ready to scale your <span className="text-indigo-400">influence?</span></h2>
           <Link to="/booking" className="relative z-10 inline-flex px-12 py-6 bg-indigo-600 text-white rounded-2xl font-black text-sm uppercase tracking-[0.2em] hover:bg-indigo-700 transition-all shadow-2xl shadow-indigo-600/30">
              Get Demo
           </Link>
        </div>
      </div>
    </div>
  );
};

export default Creators;
